export default "__VITE_ASSET__BZdEMNzV__"